import { useState, useEffect } from 'react';

/**
 * Seeded from the CURRENT match, not `false`: a layout that branches on
 * this would otherwise render its wrong half for one paint and snap.
 */
const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState<boolean>(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches,
    );

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);

        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', handleChange);

        return () => {
            mediaQueryList.removeEventListener('change', handleChange);
        };
    }, [query]);

    return matches;
};

export default useMediaQuery;